import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Icon, Button } from 'semantic-ui-react';
import UserDropdown from './UserDropdown';
import './DashboardHeader.scss';
import NewExperienceButton from './NewExperienceButton';

export default class DashboardHeader extends PureComponent {
  toggleSidebar = () => {
    const { toggleSidebar, sidebarOpened } = this.props;
    toggleSidebar(!sidebarOpened);
  };

  render() {
    const {
      title,
      logo,
      user,
      dealers,
      accessDealerRequest,
      logout,
    } = this.props;
    return (
      <div className="dashboard-header">
        <Button className="toggle-button" onClick={this.toggleSidebar}>
          <Icon name="bars" size="large" className="toggle-icon" />
        </Button>
        <NewExperienceButton />
        {logo ? (
          <div className="dashboard-header-logo-container">
            <img src={logo} alt={title} className="dashboard-header-logo" />
          </div>
        ) : (
          <div className="title">{title}</div>
        )}
        <UserDropdown
          user={user}
          dealers={dealers}
          accessDealerRequest={accessDealerRequest}
          logout={logout}
        />
      </div>
    );
  }
}

DashboardHeader.propTypes = {
  user: PropTypes.object,
  dealers: PropTypes.array,
  logout: PropTypes.func,
  accessDealerRequest: PropTypes.func,
  title: PropTypes.string,
  logo: PropTypes.string,
  sidebarOpened: PropTypes.bool,
  toggleSidebar: PropTypes.func,
};
